import React from 'react';

import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  padding-left: 9px;
`;

const LineMakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const VerticalLine = styled.div`
  height: ${(props) => (props.$isLast ? '50%' : '100%')};
  border-left: 1px solid ${(props) => props.theme.colors.text.g3};
  position: absolute;
  top: 0;
  left: 27px;
`;

const LShapeDiv = styled.div`
  flex: 0 0 auto;
  height: 0px;
  width: 32px;
  border-left: 1px solid ${(props) => props.theme.colors.text.g3};
  border-bottom: 1px solid ${(props) => props.theme.colors.text.g3};
`;

const LineMakerComp = ({ isLast = false }) => (
  <LineMakerContainer>
    <LShapeDiv />
    <VerticalLine $isLast={isLast} />
  </LineMakerContainer>
);

export default LineMakerComp;
